import { forwardRef } from 'react';
import IconBase from '../IconBase';
import { Icon } from '../types';

const UserAuthentification: Icon = forwardRef((props, ref) => (
  <IconBase viewBoxBase={780} ref={ref} {...props}>
    <path d='m600.3 370c-2.79 0-5.57-.51-8.22-1.52-18.79-7-111.48-47.77-111.48-169.98v-78.51h30v78.51c0 98.12 70.21 133.16 89.7 140.99 19.5-7.87 89.71-43.02 89.71-141.02v-78.48h30v78.48c0 122.08-92.69 162.98-111.47 170-2.66 1.01-5.45 1.52-8.24 1.52z' />
    <path d='m495 120h210v30h-210z' />
    <path d='m300 510c-82.71 0-150-67.16-150-149.71s67.29-149.71 150-149.71 150 67.16 150 149.71-67.29 149.71-150 149.71zm0-269.43c-66.17 0-120 53.7-120 119.71s53.83 119.71 120 119.71 120-53.7 120-119.71-53.83-119.71-120-119.71z' />
    <path d='m540 660h-30c0-39.17-21.23-76.31-59.77-104.58-39.94-29.29-93.3-45.42-150.23-45.42s-110.29 16.13-150.23 45.42c-38.54 28.27-59.77 65.4-59.77 104.58h-30c0-48.97 25.58-94.71 72.03-128.77 45.05-33.04 104.7-51.23 167.97-51.23s122.92 18.19 167.97 51.23c46.45 34.06 72.03 79.79 72.03 128.77z' />
  </IconBase>
));

UserAuthentification.displayName = 'UserAuthentification';

export default UserAuthentification;
